import React from "react"
import PropTypes from "prop-types"

const Course = ({ subject, number, section, name, link, location, times }) => (
  <div className="course">
    <div className="code">
      <div className="subject">{subject}</div>
      <div className="number">{number}</div>
      <div className="section">{section}</div>
    </div>
    <div className="details">
      <div className="title"><a href={link}>{name}</a></div>
      <div className="location"><a href={location.URL}>{location.room} {location.building}</a></div>
      <div className="time">{times[0]}</div>
    </div>
  </div>
)

Course.propTypes = {
  subject: PropTypes.string,
  number: PropTypes.number.isRequired,
  section: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  titleLink: PropTypes.string,
  location: PropTypes.object.isRequired,
  times: PropTypes.array.isRequired,
}

Course.defaultProps = {
  subject: `CSC`,
}

export default Course;